// ResetUserPassword.js  
import React, { useEffect, useState } from "react";
import {
    Card,
    CardContent,
    CardDescription,
    CardHeader,
    CardTitle,
    CardFooter,
} from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Label } from "../../components/ui/label";
import { Input } from "../../components/ui/input";
import { Checkbox } from "../../components/ui/checkbox";
import { app } from "../../firebase";
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import {
    collection,
    getDocs,
    getFirestore,
    updateDoc,
    doc,
} from "firebase/firestore";
import EditableUserSelect from "./EditableUserSelect";
import { useToast } from "../../hooks/use-toast";
import { useNavigate } from "react-router-dom";

// Define role styles  
const roleStyles = {
    superUser: "bg-green-100 text-green-800 border border-green-500",
    admin: "bg-[#0071bd] text-white border border-blue-700",
    student: "bg-gray-100 text-gray-800 border border-gray-300",
    receptionist: "bg-orange-100 text-orange-800 border border-orange-500",
    inactive: "bg-red-100 text-red-800 border border-red-500",
};

const ResetUserPassword = () => {
    const { toast } = useToast();
    const navigate = useNavigate();
    const [selectedUser, setSelectedUser] = useState(null);
    const [newPassword, setNewPassword] = useState('');
    const [sendEmail, setSendEmail] = useState(true);
    const [users, setUsers] = useState([]);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [filteredData, setFilteredData] = useState<any[]>([]);

    const db = getFirestore(app);
    const auth = getAuth(app);

    // Fetch users from Firestore  
    useEffect(() => {
        const fetchUsers = async () => {
            const usersCollection = collection(db, "users");
            const userDocs = await getDocs(usersCollection);
            const userData = userDocs.docs.map((doc) => ({
                id: doc.id,
                ...doc.data(),
            }));
            setUsers(userData); // Set users for filtering in EditableUserSelect  
        };
        fetchUsers();
    }, [db]);

    const handleResetPassword = async (e) => {
        e.preventDefault();
        if (selectedUser) {
            try {
                // const userRef = doc(db, "users", selectedUser.id);  
                // await updateDoc(userRef, { password: newPassword });  

                // setMessage('Password updated successfully!');  
                // setError('');  

                if (sendEmail) {
                    await sendPasswordResetEmail(auth, selectedUser.emailId);
                    toast({
                        title: "Password Reset Email Sent",
                        description: "Password Reset Email Sent to the User Successfully .",
                    });
                    setSelectedUser(null);
                    setFilteredData([]);
                    setTimeout(()=>{
                        navigate("/dashboard");
                    },2000)
                    
                }
            } catch (err) {
                setError(err.message);
                setMessage('');
            }
        } else {
            setError('Please select a user.');
        }
    };

    const setFiletredData = (data) => {
        setFilteredData(data);
    }

    return (
        <div className="container py-6 space-y-6">
            <div className="flex justify-between items-center">
                <h1 className="text -2xl font-bold">Reset User Password</h1>
            </div>

            <Card className="max-w-2xl mx-auto">
                <CardHeader>
                    <CardTitle>Reset Password</CardTitle>
                    <CardDescription>
                        Reset a user's password and optionally send them new credentials
                    </CardDescription>
                </CardHeader>
                <CardContent className="space-y-6">
                    <EditableUserSelect
                        users={users}
                        onSelectUser={setSelectedUser}
                        selectedUserRole={selectedUser?.role ?? null}
                        selectedUserID={selectedUser?.id ?? null}
                        filteredUsersData={filteredData}
                        onFilterDataChanged={setFiletredData}
                    />
                    {/* <div className="space-y-2">  
                        <Label htmlFor="new-password">New Password</Label>  
                        <Input  
                            id="new-password"  
                            type="password"  
                            placeholder="Enter new password"  
                            value={newPassword}  
                            onChange={(e) => setNewPassword(e.target.value)}  
                            disabled={!selectedUser || selectedUser.status === 'inactive'}  
                        />  
                    </div>   */}
                    <div className="flex items-start space-x-2 pt-2">
                        <Checkbox
                            checked={sendEmail}
                            onCheckedChange={(checked: any) => setSendEmail(checked)}
                            id="send-email"
                            disabled={!selectedUser || selectedUser.status === 'inactive'}
                        />
                        <div className="grid gap-1.5 leading-none">
                            <Label
                                htmlFor="send-email"
                                className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                            >
                                Send Reset password link via email
                            </Label>
                            <p className="text-sm text-gray-500">
                                User will receive an email for changing the password.
                            </p>
                        </div>
                    </div>
                </CardContent>
                <CardFooter className="flex justify-between">
                    <Button
                        variant="outline"
                        className="cursor-pointer"
                        disabled={!selectedUser || selectedUser.status === 'inactive'}
                    >
                        Cancel
                    </Button>
                    <Button
                        className="cursor-pointer"
                        onClick={handleResetPassword}
                        disabled={!selectedUser || selectedUser.status === 'inactive' || sendEmail === false}
                    >
                        Reset Password
                    </Button>
                </CardFooter>
            </Card>
            {message && <p className="mt-4 text-green-600">{message}</p>}
            {error && <p className="mt-4 text-red-600">{error}</p>}
        </div>
    );
};

export default ResetUserPassword;  